import { Grid } from '@material-ui/core'
import { RopWLFilter } from 'components/Rop/RopWLFilter/RopWLFilter'
import { RopWLTable } from 'components/Rop/RopWLTable/RopWLTable'

export const WlList = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <RopWLFilter />
      </Grid>
      <Grid item xs={12} style={{ margin: '16px 0 80px 0' }}>
        <RopWLTable />
      </Grid>
    </Grid>
  )
}
